import { auth, Gprovider, database } from '../../Firebase';

var privateUserChecked = false;
// unfiltered user data
var privateUser = null;
// user data containing only necessary fields
var databaseUser = null;

// Handle login data
const updateUserdata = (userdata) => {
    return new Promise((resolve, reject) => {
        database.collection("users").doc(userdata.uid).get().then((doc) => {
            let docdata = {};
            let userobj = {
                role: "member",
                uid: userdata.uid,
                access_level: 0,
                imagelink: userdata.photoURL,
                displayName: userdata.displayName,
                registered_access: ["normal"],
                savefile: "a;<>W IxIxIxIuIuIuIwI>\\+b+W I[_*(!|P(_*~IBI%]9$IBII@P[@9$-[+IBII@P9*@&+IBII@P~-^+IBI~-^+P7\\7@%IsBBI~-^+P7\\7@%P[@^-Iywsz uBttvtBBtusyII@P[*$-&+IBII@P[*$-&P0*]8%-_IBII@P8@~P8*}IBII@P^-~7P8*}IBII@P}(IBII@P[_*(!@-+IBII+--0P8*}ItyBvtvIAzAwwzIysxvvsItusyzuII+--0P8@~P8*}IAxBtzzIzBuxAAItwyyswIywzxuuII+--0P^-~7P8*}IxuvxyvIAwysAsIxxtyxxIsyAtBsII8P+!-%%|IBII8P+!-%%|P(*{-_IBII8P+!-%%|P(*{-_(*@&[IBII8P+!-%%|P[_*(!|IBII8P-^;IBII8P-^;P(*{-_IBII8P-^;P(*{-_(*@&[IBII8P-^;P[_*(!|IBI(%7|\\-_+@*&'B B yIiT$T$QId{�'}'{\\"
            }
            privateUser = { ...userobj, ...privateUser }
            if (doc.exists) {
                docdata = doc.data();
                privateUser = { ...privateUser, ...doc.data() };
            }
            databaseUser = { ...userobj, ...docdata };
            // Update data if outdated
            if (JSON.stringify(docdata, Object.keys(docdata).sort()) !== JSON.stringify(databaseUser, Object.keys(databaseUser).sort())) {
                database.collection("users").doc(userdata.uid).set(databaseUser)
            }
            resolve();
        }, err => {
            reject(err);
        })
    });
}

const parseUser = (user) => {
    return {
        displayName: user.displayName,
        email: user.email,
        emailVerified: user.emailVerified,
        isAnonymous: user.isAnonymous,
        metadata: user.metadata,
        multifactor: user.multifactor,
        phoneNumber: user.phoneNumber,
        photoURL: user.photoURL,
        providerData: user.providerData,
        providerId: user.providerId,
        refreshToken: user.refreshToken,
        tenantId: user.tenantId,
        uid: user.uid,
    }
}

// Handle if previously redirected
auth.getRedirectResult()
    .then((result) => {
        //if (result.credential) {
        //    /** @type {firebase.auth.OAuthCredential} */
        //    var credential = result.credential;

        //    // This gives you a Google Access Token. You can use it to access the Google API.
        //    var token = credential.accessToken;
        //    // ...
        //}
        // The signed-in user info.
        if (result.user) {
            privateUser = parseUser(result.user);
            updateUserdata(privateUser).then(() => {
                //localStorage.setItem("firebaseBrowserAuth", JSON.stringify(privateUser))
                privateUserChecked = true;
            })
        }
    }).catch((error) => {
        console.log(error);
        // Handle Errors here.
        //var errorCode = error.code;
        //var errorMessage = error.message;
        // The email of the user's account used.
        //var email = error.email;
        // The firebase.auth.AuthCredential type that was used.
        //var credential = error.credential;
        // ...
    });
//if (localStorage.getItem("firebaseBrowserAuth")) {
//    try {
//        privateUser = JSON.parse(localStorage.getItem("firebaseBrowserAuth"));
//        privateUserChecked = true;
//    } catch (e) {
//        // JSON ERROR
//    }
//}
// Handle if previously logged in
auth.onAuthStateChanged((user) => {
    if (user) {
        privateUser = parseUser(user);
        updateUserdata(privateUser).then(() => {
            privateUserChecked = true;
        }, err => {
            privateUserChecked = true;
            privateUser = "no user";
        })
    } else {
        privateUserChecked = true;
        privateUser = "no user";
    }
})

var userChangeCallbacks = [];

export const getSettings = () => {
    return new Promise((resolve, reject) => {
        database.collection("database").doc("website-setting").get().then((doc) => {
            resolve(doc.data());
        }).catch((err) => {
            reject(err);
        });
    });
}

export const user = {
    signIn: () => {
        return new Promise((resolve, reject) => {
            auth.signInWithPopup(Gprovider)
                .then((result) => {
                    /** @type {firebase.auth.OAuthCredential} */
                    //var credential = result.credential;

                    // This gives you a Google Access Token. You can use it to access the Google API.
                    //var token = credential.accessToken;
                    // The signed-in user info.
                    privateUserChecked = true;
                    privateUser = result.user;
                    resolve(privateUser);
                    // ...
                }).catch((error) => {
                    // Handle Errors here.
                    //var errorCode = error.code;
                    //var errorMessage = error.message;
                    // The email of the user's account used.
                    //var email = error.email;
                    // The firebase.auth.AuthCredential type that was used.
                    //var credential = error.credential;
                    // ...
                    reject();
                });
        })
    },
    signInRedirect: () => {
        return new Promise((resolve, reject) => {
            auth.signInWithRedirect(Gprovider).then((val) => {
                resolve(val);
            }).catch((err) => {
                reject(err);
            });
        })
    },
    get: () => {
        return new Promise((resolve, reject) => {
            let timeout = 10000;
            const recheckUser = () => {
                if (privateUserChecked) {
                    resolve(privateUser);
                } else {
                    if (timeout <= 0) {
                        reject("10s timeout");
                    } else {
                        timeout -= 50;
                        setTimeout(recheckUser, 50);
                    }
                }
            }
            recheckUser();
        })
    },
    getToken: () => {
        return new Promise((resolve, reject) => {
            auth.currentUser.getIdToken(true).then(function (idToken) {
                resolve(idToken)
            }).catch(function (error) {
                reject(error)
            });
        })
    },
    signOut: () => {
        auth.signOut().then(() => {
            //localStorage.removeItem("firebaseBrowserAuth");
            privateUserChecked = true;
            privateUser = "no user";
            for (var i = 0; i < userChangeCallbacks.length; i++) {
                userChangeCallbacks[i]();
            }
            // Sign-out successful.
        }).catch((error) => {
            // An error happened.
        });
    },
    setData: (data) => {
        databaseUser = { ...databaseUser, ...data };
        privateUser = { ...privateUser, ...data }
        return privateUser;
    },
    saveData: () => {
        return new Promise((resolve, reject) => {
            if (privateUser && databaseUser) {
                database.collection("users").doc(privateUser.uid).set(databaseUser).then(() => {
                    resolve();
                }).catch((err) => {
                    reject(err);
                });
            } else {
                reject("not logged in");
            }
        })
    },
    onChangeStateAdd: (callback) => {
        return userChangeCallbacks.push(callback);
    },
    onChangeStateRemove: (callback) => {
        if (userChangeCallbacks.indexOf(callback) !== -1) {
            userChangeCallbacks.splice(userChangeCallbacks.indexOf(callback), 1);
        }
    },
    getUserData: (collection, doc) => {
        return new Promise((resolve, reject) => {
            if (privateUser) {
                if (doc == null) {
                    database.collection("userdata").doc(privateUser.uid).collection(collection).get().then((QuerySnapshot) => {
                        resolve(QuerySnapshot);
                    }).catch((err) => {
                        reject(err);
                    });
                } else {
                    database.collection("userdata").doc(privateUser.uid).collection(collection).doc(doc).get(databaseUser).then((DocumentReference) => {
                        resolve(DocumentReference);
                    }).catch((err) => {
                        reject(err);
                    });
                }
            } else {
                reject("not logged in");
            }
        })
    },
    setUserData: (collection, doc, data) => {
        return new Promise((resolve, reject) => {
            if (privateUser) {
                if (doc == null) {
                    database.collection("userdata").doc(privateUser.uid).collection(collection).add(data).then(() => {
                        resolve();
                    }).catch((err) => {
                        reject(err);
                    });
                } else {
                    database.collection("userdata").doc(privateUser.uid).collection(collection).doc(doc).set(data).then(() => {
                        resolve();
                    }).catch((err) => {
                        reject(err);
                    });
                }
            } else {
                reject("not logged in");
            }
        })
    },
}